var map = {
	"./music-instructions.json": 4532,
	"./music-library-intro2024.json": 4533,
	"./music-library-launch2024.json": 4534,
	"./music-progression.json": 4535,
	"./startSourcesAdvanced.json": 4536,
	"./startSourcesSimple.json": 4537,
	"./startSourcesSimple2.json": 4538,
	"./startSourcesTracks.json": 4539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4297;